import { gql } from '@apollo/client';

export const MUTATION_ADD_AI_CONTEXT = gql`
  mutation AddAIContext(
    $file: Upload!
    $category: String = "document"
    $municipality_code: String
  ) {
    addAIContext(
      file: $file
      category: $category
      municipality_code: $municipality_code
    ) {
      id
      uploaded_file {
        id
        filename
        original_name
        file_url
        file_size
        mime_type
        category
        municipality_code
        created_at
      }
      vector_data {
        total_chunks
        chunks_processed
        title
        category
        municipality_code
      }
      metadata
      created_at
    }
  }
`;

export const MUTATION_REMOVE_AI_CONTEXT = gql`
  mutation RemoveAIContext($uploaded_file_id: String!) {
    removeAIContext(uploaded_file_id: $uploaded_file_id)
  }
`;

export const MUTATION_CREATE_CONVERSATION = gql`
  mutation CreateConversation($input: CreateConversationInput!) {
    createConversation(input: $input) {
      id
      municipality_code
      user_id
      title
      created_at
      updated_at
      messages {
        id
        conversation_id
        role
        content
        created_at
      }
    }
  }
`;

export const MUTATION_UPDATE_CONVERSATION_TITLE = gql`
  mutation UpdateConversationTitle(
    $conversation_id: String!
    $title: String!
  ) {
    updateConversationTitle(conversation_id: $conversation_id, title: $title) {
      id
      municipality_code
      user_id
      title
      created_at
      updated_at
      messages {
        id
        conversation_id
        role
        content
        created_at
      }
    }
  }
`;

export const MUTATION_DELETE_CONVERSATION = gql`
  mutation DeleteConversation($conversation_id: String!) {
    deleteConversation(conversation_id: $conversation_id)
  }
`;

export const MUTATION_ADD_CITY_KNOWLEDGE = gql`
  mutation AddCityKnowledge($input: AddCityKnowledgeInput!) {
    addCityKnowledge(input: $input) {
      id
      municipality_code
      title
      content
      category
      created_at
      municipality {
        municipality_code
        name_municipality
        name_uf
        sigla_uf
      }
    }
  }
`;

export const MUTATION_DELETE_CITY_KNOWLEDGE = gql`
  mutation DeleteCityKnowledge($id: String!) {
    deleteCityKnowledge(id: $id)
  }
`;

export const MUTATION_SEND_CHAT_MESSAGE = gql`
  mutation SendChatMessage($input: ChatMessageInput!) {
    sendChatMessage(input: $input) {
      response
      conversation_id
      conversation_history {
        id
        conversation_id
        role
        content
        created_at
      }
    }
  }
`;
